import React from "react";
import PropTypes from "prop-types";

import Str from "shared/components/Str";
import getImagePath from "shared/util/getImagePath";
import goToUrl from "shared/util/goToUrl";

import {
	CopyText,
} from "shared/components/VoucherModal/constants";

const SignupOrLogin = ({ onSignup, onLogin }) => (
	<div className="voucherContents">
		<img className="voucherContents-almostThere" src={`${getImagePath()}media/img/vouchers/Asset 13@4x.png`} alt="voucher" />
		<div className="voucherContents-header">{CopyText.ALMOST_THERE}</div>
		<Str className="voucherContents-sub almostThere">
			Sign in or create an account to redeem your promotion.
		</Str>
		<button
			type="button"
			className="big blue flatbutton login"
			onClick={() => {
				onLogin();
				goToUrl("/login");
			}}
		>
			<Str>Sign in</Str>
		</button>
		<button
			type="button"
			className="big blue flatbutton createAccount"
			onClick={() => {
				onSignup();
				goToUrl("/signup");
			}}
		>
			<Str>Create Account</Str>
		</button>
	</div>
);

SignupOrLogin.propTypes = {
	onSignup: PropTypes.func,
	onLogin: PropTypes.func,
};

SignupOrLogin.defaultProps = {
	onSignup: () => {},
	onLogin: () => {},
};

export default SignupOrLogin;



// WEBPACK FOOTER //
// ./src/shared/components/VoucherModal/SignupOrLogin.jsx